export enum BonusType {
  legacy = "lg",
  apprentice = "ap",
  associationTime = "as",
  shortShift = "sh",
  custom = "cs",
  solo = "solo",
  zeroPayment = "0",
  venueCaptain = "vc",
}

export namespace BonusType {
  export function automaticReasons() {
    return [
      BonusType.shortShift,
      BonusType.solo,
      BonusType.venueCaptain,
      BonusType.custom,
    ];
  }

  export function toShortReason(bonusType: BonusType | string): string {
    switch (bonusType) {
      case BonusType.legacy:
        return "Lg";
      case BonusType.apprentice:
        return "Ap";
      case BonusType.associationTime:
        return "Asc";
      case BonusType.shortShift:
        return "Sh";
      case BonusType.custom:
        return "Cs";
      case BonusType.solo:
        return "Sol";
      case BonusType.zeroPayment:
        return "0d";
      case BonusType.venueCaptain:
        return "VC";
    }
    return "UK";
  }

  export function toLongReason(bonusType: BonusType | string): string {
    switch (bonusType) {
      case BonusType.legacy:
        return "Legacy";
      case BonusType.apprentice:
        return "Apprentice";
      case BonusType.associationTime:
        return "Association";
      case BonusType.shortShift:
        return "Short shift";
      case BonusType.custom:
        return "Custom";
      case BonusType.solo:
        return "Solo";
      case BonusType.zeroPayment:
        return "Zero payment";
      case BonusType.venueCaptain:
        return "Venue captain";
    }
    return "Unknown";
  }

  export function defaultBonusForReason(
    bonusType: BonusType,
    base: number,
  ): number {
    switch (bonusType) {
      case BonusType.shortShift:
        return 3.0;
      case BonusType.custom:
        return 5.0;
      case BonusType.solo:
        return base * 0.5;
      case BonusType.venueCaptain:
        return 5.0;
    }
    return 0;
  }
}
